import React, { useState, useEffect } from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../FireBase"; // adjust path


export default function UpdateNoticeAdmin() {
  const [days, setDays] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    const existingDays = localStorage.getItem("update_days_count");
    if (existingDays) {
      setDays(existingDays);
    }
  }, []);
const saveDays = async () => {
  if (!days || days <= 0) {
    alert("Enter valid number of days");
    return;
  }

  try {
    const ref = doc(db, "settings", "app-update-notification");

    await setDoc(
      ref,
      {
        daysCount: Number(days),
        startDate: new Date(),     // starts from today
        updatedAt: serverTimestamp(),
      },
      { merge: true } // 🔥 updates same document every time
    );

    setSaved(true);
  } catch (error) {
    console.error("Failed to save update notification", error);
    alert("Failed to save");
  }
};

  return (
    <>
    
    <Card className="shadow-sm">
        
      <Card.Body>
        <Card.Title>📱 Update Popup Control</Card.Title>

        {saved && <Alert variant="success">Update notice activated</Alert>}

        <Form.Group className="mb-3">
          <Form.Label>Show Update Popup For (Days)</Form.Label>
          <Form.Control
            type="number"
            placeholder="Example: 15"
            value={days}
            onChange={(e) => setDays(e.target.value)}
          />
        </Form.Group>

        <Button variant="success" onClick={saveDays}>
          Save
        </Button>
      </Card.Body>
    </Card>
    </>
  );
}
